import React, {type ReactNode} from 'react';

import {useSelector} from 'react-redux';

import {CurrentUserSelector} from 'app/current-user/api';
import {TeamsSelectMulti} from 'app/teams/components/TeamsSelect';
import {gt} from 'app/utils/i18n';

import type {ActionMeta} from 'app/components/general/SweetReactSelect';
import type {TeamSerializedType} from 'sweet-types';

type DefaultProps = {
  disabledText?: (team: TeamSerializedType) => string | undefined;
};
type Props = DefaultProps & {
  onChange: (teams: Array<TeamSerializedType>) => unknown;
  selected: Array<TeamSerializedType>;
  children?: ReactNode;
};

export function CollapsableTeamPickerForm({
  onChange,
  selected,
  children,
}: Props) {
  const {is_super_manager: isSuperManager} = useSelector(
    (state) => CurrentUserSelector(state).data!
  );

  function handleChangeTeams(
    teams: Array<TeamSerializedType>,
    meta: ActionMeta<TeamSerializedType>
  ) {
    let newTeams = teams;
    if (meta.action === 'select-option') {
      newTeams = [meta.option, ...selected];
    }
    onChange(newTeams);
    return Promise.resolve(true);
  }

  return (
    <>
      <TeamsSelectMulti
        canCreate={isSuperManager}
        disabled={false}
        selected={selected}
        refetchDataOnOpen={true}
        onChange={handleChangeTeams}
        placeholder={gt('Add to teams')}
      />
      {children}
    </>
  );
}
